import { useRef } from 'react';

import { CloseIcon } from '@braskai/icons';
import { useClickAway } from 'react-use';

import { Loader } from '@/shared/ui/Loader';

import { useHubSpotChatStore } from '../hooks/useHubSpotChatStore';
import { useInitHubSpotChat } from '../hooks/useInitHubSpotChat';
import { SCloseButton, SHubSpotWrapper, SLoadingHeader } from './styled';

type HubSpotChatProps = {
  defaultSpaceId?: string;
};

export const HubSpotChat = ({ defaultSpaceId }: HubSpotChatProps = {}) => {
  const { hideChat, isLoading, isOpen } = useHubSpotChatStore();
  const wrapperRef = useRef<HTMLDivElement>(null);

  useClickAway(wrapperRef, () => {
    if (isOpen) {
      hideChat();
    }
  });
  useInitHubSpotChat({ defaultSpaceId });

  return (
    <SHubSpotWrapper id="hubspot-conversations-inline-embed-selector" $isOpen={isOpen} ref={wrapperRef}>
      {isLoading && (
        <>
          <SCloseButton data-testid="hub-spot-chat-hide-chat" size="lg" onClick={hideChat}>
            <CloseIcon />
          </SCloseButton>
          <SLoadingHeader />
          <Loader />
        </>
      )}
    </SHubSpotWrapper>
  );
};
